import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["ElementCarousel"] */ "/app/src/app/components/ElementCarousel.tsx");
